import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  AGREEMENT_FETCH: createSagaAction('AGREEMENT_FETCH'),

  AGREEMENT_REFRESH: createSagaAction('AGREEMENT_REFRESH'),

  AGREEMENT_CREATE: createSagaAction('AGREEMENT_CREATE'),
  AGREEMENT_UPDATE: createSagaAction('AGREEMENT_UPDATE'),
  AGREEMENT_DELETE: createSagaAction('AGREEMENT_DELETE'),

  AGREEMENT_FOLDER_CREATE: createSagaAction('AGREEMENT_FOLDER_CREATE'),
  AGREEMENT_FOLDER_UPDATE: createSagaAction('AGREEMENT_FOLDER_UPDATE'),
  AGREEMENT_FOLDER_DELETE: createSagaAction('AGREEMENT_FOLDER_DELETE'),

  UPLOAD_AGREEMENT_ATTACHMENT: createSagaAction('UPLOAD_AGREEMENT_ATTACHMENT'),
  GET_AGREEMENT_ATTACHMENTS: createSagaAction('GET_AGREEMENT_ATTACHMENTS'),
  UPDATE_AGREEMENT_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_AGREEMENT_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_AGREEMENT_ATTACHMENT: createSagaAction('DELETE_AGREEMENT_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobAgreementRefresh: ({ jobId, folderId }) => ({
    type: constants.AGREEMENT_REFRESH.ACTION,
    jobId,
    folderId
  }),

  createAgreement: ({ jobId, formData, folderId }) => ({
    type: constants.AGREEMENT_CREATE.ACTION,
    jobId,
    formData,
    folderId
  }),

  updateAgreement: ({ jobId, formData, agreementId, folderId }) => ({
    type: constants.AGREEMENT_UPDATE.ACTION,
    jobId,
    formData,
    agreementId,
    folderId
  }),

  deleteAgreement: ({ agreementId, jobId, folderId }) => ({
    type: constants.AGREEMENT_DELETE.ACTION,
    jobId,
    agreementId,
    folderId
  }),

  // Attachment actions
  uploadAgreementAttachment: ({ formData }) => ({
    type: constants.UPLOAD_AGREEMENT_ATTACHMENT.ACTION,
    formData
  }),

  createFolder: ({ name, parentId, jobId, folderId }) => ({
    type: constants.AGREEMENT_FOLDER_CREATE.ACTION,
    name,
    parentId,
    jobId,
    folderId
  }),

  updateFolder: ({ name, folderId, jobId, currentFolderId }) => ({
    type: constants.AGREEMENT_FOLDER_UPDATE.ACTION,
    name,
    folderId,
    jobId,
    currentFolderId
  }),

  deleteFolder: ({ folderId, jobId, currentFolderId }) => ({
    type: constants.AGREEMENT_FOLDER_DELETE.ACTION,
    folderId,
    jobId,
    currentFolderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.AGREEMENT_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.AGREEMENT_REFRESH.SUCCESS:
      return {
        ...state,
        agreements: action.payload
      }
    case constants.AGREEMENT_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.AGREEMENT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.AGREEMENT_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.AGREEMENT_FOLDER_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.AGREEMENT_FOLDER_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.AGREEMENT_FOLDER_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_AGREEMENT_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_AGREEMENT_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false,
        attachmentId: action.payload.attachmentId
      }

    case constants.GET_AGREEMENT_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_AGREEMENT_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobPaymentRequestsAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_AGREEMENT_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_AGREEMENT_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_AGREEMENT_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobAgreementActions.js